export const defaultPricingConfiguration = () => ({
  rentalPreconditions: {
    minimalBalance: {},
  },
  freeMinutesPerDay: null,
  freeMinutesPerPeriod: null,
  priceList: [],
  deductions: {
    bikeLeftInZone: {},
  },
  penalties: {
    bikeLeftOutOfPreferredZone: {},
    bikeLeftOutOfOperatorZone: {},
  },
  cardsPriority: [],
});

const voucherPriceList = () => [
  {
    upTo: null,
    fee: {
      type: 'free',
      rate: null,
      interval: null,
    },
  },
];

export const normalizePlanPayload = data => {
  const pricingConfiguration = data.pricingConfiguration || defaultPricingConfiguration();

  if (!data.voucherOnly || (pricingConfiguration.priceList && pricingConfiguration.priceList.length)) {
    return {
      ...data,
      pricingConfiguration,
    };
  }

  return {
    ...data,
    pricingConfiguration: {
      ...pricingConfiguration,
      priceList: voucherPriceList(),
    },
  };
};

export class PlanModel {
  constructor(data) {
    data = data || {};
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.price = data.price;
    this.validity = data.validity;
    this.pricingConfiguration = data.pricingConfiguration || defaultPricingConfiguration();
    this.internalUseOnly = data.internalUseOnly;
    this.dedicated = data.dedicated;
    this.bikeTypeId = data.bikeTypeId || null;
    this.excludeInactiveMonths = data.excludeInactiveMonths;
    this.voucherOnly = data.voucherOnly || false;
  }
}

export const PlanValidityTypes = Object.freeze({
  daily: { value: 'daily', name: 'Dzień' },
  monthly: { value: 'monthly', name: 'Miesiąc' },
  quarterly: { value: 'quarterly', name: 'Kwartał' },
  semiAnnual: { value: 'semiAnnual', name: '6 miesięcy' },
  annualy: { value: 'annualy', name: 'Rok' },
  eightHours: { value: 'eightHours', name: '8 godzin' },
  twelveHours: { value: 'twelveHours', name: '12 godzin' },
  twentyFourHours: { value: 'twentyFourHours', name: '24 godziny' },
});

export const ParseDedicatedPlansToSelect = (dedicatedPlans) => {
  const options = {}
  dedicatedPlans.forEach(x => {
    options[x.id] = {value: x.id, name: x.name}
  })
  return options;
}
